import { render } from "./menu-image.vue?vue&type=template&id=30d3cd6e"
import script from "./menu-image.vue?vue&type=script&lang=js"
export * from "./menu-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__